module.exports = __webpack_public_path__ + "static/media/ask_mona_studio_logo_white.1d36135d.png";